import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { CommonStoreService } from '../services/common-store.service';

export const resetStoreGuard: CanActivateFn = () => {
  const store = inject(CommonStoreService);
  store.reset();
  return true;
};
